"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDialogRepo = exports.DialogRepo = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
class DialogRepo extends ObservableEntity_1.ObservableEntity {
}
exports.DialogRepo = DialogRepo;
function makeDialogRepo() {
    return new DialogRepoImp();
}
exports.makeDialogRepo = makeDialogRepo;
class DialogRepoImp extends DialogRepo {
    constructor() {
        super(...arguments);
        this.dialogQueue = [];
    }
    get activeDialog() {
        return this.dialogQueue.length > 0 ? this.dialogQueue[0] : null;
    }
    submitDialog(dialog) {
        this.dialogQueue.push(dialog);
        if (this.activeDialog === dialog) {
            dialog.isOpen = true;
        }
        this.notify();
    }
    activeDialogHasClosed() {
        const activeDialog = this.activeDialog;
        if (activeDialog !== null) {
            this.dialogQueue.splice(0, 1);
            const newActiveDialog = this.activeDialog;
            if (newActiveDialog !== null) {
                newActiveDialog.isOpen = true;
            }
            this.notify();
        }
    }
}
